import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import { TenantAddonConstants } from '../../tenant-addons';
import { OmnibarEntry } from '../omnibar-interfaces';
import { citizensOverviewAreaPathName } from '../../../areas/citizen/authority/citizen-authority-area-pathnames';
import { citizensAreaSocialProviderPathName } from '../../../areas/citizen/authority/overview/citizens-overview-area-pathnames';
import { serviceProviderUnitCalendarAreaPathName } from '../../../areas/service-provider-unit-calendar/service-provider-unit-calendar-area-pathnames';
import { serviceProviderResourceUtilizationAreaPathName } from '../../../areas/service-provider-resource-utilization/resource-utilization-area-pathnames';
import { serviceProviderUseOfForceAreaPathName } from '../../../areas/service-provider-use-of-force/service-provider-use-of-force-area-pathnames';
import { catalogCorrectionsToggle } from '../utils/catalog-corrections';

const group = 'Udfører';

const functions: OmnibarEntry[] = [
  {
    id: '6a0f3b52-1d4e-4c8b-9f27-3e5d8a1c7b40',
    label: 'Borgere (udfører)',
    context: 'none',
    group,
    url: `/${citizensOverviewAreaPathName}/${citizensAreaSocialProviderPathName}`,
    featureToggleRequired: catalogCorrectionsToggle,
    requiresServiceProviderAreaAccess: true,
    resourceActions: [
      { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.SocialProviderSearch },
      { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.MedicalCollaborationSearch },
    ],
  },
  {
    id: '0d7c2e91-58a3-4b6f-a1e4-9c2b7f3d5e86',
    label: 'Fælles kalender',
    context: 'none',
    group,
    url: `/${serviceProviderUnitCalendarAreaPathName}`,
    featureToggleRequired: catalogCorrectionsToggle,
    tenantAddonEnabled: [TenantAddonConstants.JointCalendar],
    requiresServiceProviderRole: true,
    resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.SocialProviderUnit }],
  },
  {
    id: '4b8e1f6a-2c9d-4d3e-b7a5-8f1c6e2d9a37',
    label: 'Ressourceforbrug',
    context: 'none',
    group,
    url: `/${serviceProviderResourceUtilizationAreaPathName}`,
    featureToggleRequired: [catalogCorrectionsToggle, 'EnableOfferResourceImprovements'],
    tenantAddonEnabled: [TenantAddonConstants.SocialUdfoerer],
    resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.ResourceUtilization }],
  },
  {
    id: 'e3a59c17-7b2f-4e8d-96c1-5d4a8b0f2e73',
    label: 'Magtanvendelser',
    context: 'none',
    group,
    url: `/${serviceProviderUseOfForceAreaPathName}`,
    featureToggleRequired: [catalogCorrectionsToggle, 'ShowUseOfForce'],
    tenantAddonEnabled: [TenantAddonConstants.SocialUdfoerer],
    resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.UseOfForceIncident }],
  },
];

export default functions;
